/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedShopConsentDto } from '../models/PaginatedShopConsentDto';
import type { ShopAgreementCreateRequest } from '../models/ShopAgreementCreateRequest';
import type { ShopConsentDto } from '../models/ShopConsentDto';
import type { ShopLoanCalculationSettings } from '../models/ShopLoanCalculationSettings';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ShopSettingsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ShopLoanCalculationSettings OK
     * @throws ApiError
     */
    public updateShopLoanCalculationSettings({
        requestBody,
    }: {
        requestBody: ShopLoanCalculationSettings,
    }): CancelablePromise<ShopLoanCalculationSettings> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/shop-settings/loan-calculation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public createShopAgreement({
        shopId,
        requestBody,
    }: {
        shopId: string,
        requestBody: ShopAgreementCreateRequest,
    }): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/shop-settings/{shopId}/agreement/create',
            path: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedShopConsentDto OK
     * @throws ApiError
     */
    public getAllShopAgreements({
        shopId,
        type = 'INSTALLMENT',
        page,
        limit = 10,
        sort = 'desc',
        sortBy = 'version',
    }: {
        shopId: string,
        type?: 'INSTALLMENT' | 'PDPA',
        page?: number,
        limit?: number,
        sort?: string,
        sortBy?: string,
    }): CancelablePromise<PaginatedShopConsentDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shop-settings/{shopId}/agreements',
            path: {
                'shopId': shopId,
            },
            query: {
                'type': type,
                'page': page,
                'limit': limit,
                'sort': sort,
                'sortBy': sortBy,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopConsentDto OK
     * @throws ApiError
     */
    public getShopAgreementById({
        shopId,
        id,
    }: {
        shopId: string,
        id: string,
    }): CancelablePromise<ShopConsentDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shop-settings/{shopId}/agreement/{id}',
            path: {
                'shopId': shopId,
                'id': id,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ShopConsentDto OK
     * @throws ApiError
     */
    public getLatestShopAgreementByShopId({
        shopId,
        type,
    }: {
        shopId: string,
        type: 'INSTALLMENT' | 'PDPA',
    }): CancelablePromise<ShopConsentDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/shop-settings/{shopId}/agreement/latest',
            path: {
                'shopId': shopId,
            },
            query: {
                'type': type,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
